import { HttpService, HttpServiceResponse } from '../shared'
import { TreasuryPage, TreasuryServerData } from './treasury.types'

export class TreasuryProvider {
  constructor(private http: HttpService, private baseUrl: string) {}

  private get url(): string {
    return `${this.baseUrl}/tr_livedata_api.php`
  }

  public get(page: TreasuryPage): Promise<HttpServiceResponse<TreasuryServerData>> {
    return this.http.post(`${this.url}?page=${page}`)
  }
}
